import { getTranslatedText } from '@nile/components';
import React, { useEffect } from 'react';
import { SVGIcon } from '@superops/super-icons';
import styled from 'styled-components';
import { Tooltip } from 'react-clone-tippy';
import { useStopwatch } from 'react-timer-hook';
import { Avatar, TextStyle } from '@superops/ui-design-system';
import { useIntl } from 'react-intl';

const TimeWrapper = styled.div`
  min-width: 115px;
  .timer-cell {
    background: ${(props) =>
      props.highlight
        ? 'var(--sops-worklog-timer-highlight-bg)'
        : 'var(--sops-worklog-timer-bg)'};
    border-radius: 5px;
    padding: 0 10px;
    min-height: 38px;
    transition: background 200ms linear;
  }
  .manual-tag {
    background: #f6ddc6;
    border-radius: 2px;
    padding: 0px 5px;
    font-size: 12px;
    line-height: 20px;
  }
`;

function Timer(props) {
  const { timer, updateWorklogTimerEntry } = props;
  const { running, state, timespent, timerId, type } = timer;
  const intl = useIntl();
  const autoTimer = type === 'AUTOMATIC';
  let stopwatchOffset = new Date();
  // if (!autoTimer) {
  //   timer.segments.forEach((segmnt) => {
  //     totalTimespent += parseFloat(segmnt?.timespent).toFixed(2) * 60 * 60;
  //   });
  // } else {
  // totalTimespent = parseFloat(timespent).toFixed(2);
  // }
  stopwatchOffset.setSeconds(stopwatchOffset.getSeconds() + timespent);
  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    reset
  } = useStopwatch({
    autoStart: running,
    offsetTimestamp: stopwatchOffset
  });

  useEffect(() => {
    stopwatchOffset = new Date();
    stopwatchOffset.setSeconds(stopwatchOffset.getSeconds() + timespent);
    reset(stopwatchOffset, running);
  }, [timespent, running]);

  const formatTime = (time) => {
    return String(time).padStart(2, '0');
  };
  const updateWorklogEntry = (timerData) => {
    updateWorklogTimerEntry({
      variables: {
        timerEntryInput: {
          timerId: timerData?.timerId,
          running: !timerData?.running
        }
      }
    });
  };
  return (
    <TimeWrapper
      className={`flex ${autoTimer ? 'pointer' : ''}`}
      onClick={() => {
        if (autoTimer) updateWorklogEntry(timer);
      }}
    >
      <div className="timer-cell fw g10 fx center jspbtwn">
        {autoTimer ? (
          <SVGIcon name={running ? 'Pause' : 'Play'} />
        ) : (
          <Tooltip
            title={getTranslatedText(intl, 'workItem.manualTimer')}
            delay={400}
            duration={250}
            position="top-start"
            inertia
            trigger="mouseenter"
            animation="shift"
            animateFill={false}
          >
            {/* <Avatar initials="M" size="extraSmall" /> */}
            <div className="manual-tag">M</div>
          </Tooltip>
        )}
        <TextStyle weight="SemiBold">
          {/* {days ? <span>{formatTime(days)}:</span> : ''} */}
          <span>{formatTime(days ? days * 24 + hours : hours)}</span>:
          <span>{formatTime(minutes)}</span>:<span>{formatTime(seconds)}</span>
        </TextStyle>
      </div>
    </TimeWrapper>
  );
}

export default Timer;
